import { f as s } from "./index743.mjs";
import { f as t } from "./index758.mjs";
import { c as i } from "./index807.mjs";
var n = s, o = t, f = i, a = Object, c = n("".split), l = o(function() {
  return !a("z").propertyIsEnumerable(0);
}) ? function(r) {
  return f(r) === "String" ? c(r, "") : a(r);
} : a;
export {
  l as i
};
